import { Component, Vue } from 'vue-property-decorator';
import { SearchResultItem } from '@/types/SearchResultItem';
import { Color } from '@/types/entities/Color';
import { Fuel } from '@/types/entities/Fuel';
import { Make } from '@/types/entities/Make';
import { Marina } from '@/types/entities/Marina';

@Component
export default class HelpersMixin extends Vue {
  get years(): Array<{ value: number, title: number }> {
    const startYear = 1950;
    const lastYearForSelector = (new Date()).getFullYear() + 1;
    const result = [];

    for (let year = startYear; year < lastYearForSelector; year++) {
      result.push({
        value: year,
        title: year
      });
    }

    return result;
  }

  get colors() {
    return this.$store.state.colors.items.data.map((color: SearchResultItem<Color>) => {
      return {
        value: color.id,
        title: color.attributes.name
      };
    });
  }

  get fuelTypes() {
    return this.$store.state.fuels.items.data.map((fuel: SearchResultItem<Fuel>) => {
      return {
        value: fuel.id,
        title: fuel.attributes.name
      };
    });
  }

  get makes() {
    return this.$store.state.makes.items.data.map((make: SearchResultItem<Make>) => {
      return {
        value: make.id,
        title: make.attributes.name
      };
    });
  }

  get marinas(): Array<{ value: number, title: string }> {
    return this.$store.state.marinas.items.data
      .sort((marina1: SearchResultItem<Marina>, marina2: SearchResultItem<Marina>) => {
        if (marina1.attributes.name > marina2.attributes.name) {
          return 1;
        }

        if (marina1.attributes.name < marina2.attributes.name) {
          return -1;
        }

        return 0;
      })
      .map((marina: SearchResultItem<Marina>) => {
        return {
          title: marina.attributes.name,
          value: marina.id
        };
      });
  }
}
